module.exports = __webpack_public_path__ + "static/assets/14df36a7e3b083d0d29ab75421c352fa.svg";